/**
 * Application Configuration
 * 
 * Central configuration file for environment variables and app settings.
 * All environment variables should be accessed through this file.
 */

/**
 * Backend API Base URL
 * Default: http://localhost:6100
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000'

/**
 * Environment
 */
export const IS_PRODUCTION = import.meta.env.PROD
export const IS_DEVELOPMENT = import.meta.env.DEV

/**
 * App Metadata
 */
export const APP_NAME = 'AIRA'
export const APP_VERSION = '1.0.0'

